import React, { useState, useEffect } from "react";
import routes from "shared/utils/constants/routes";
import styles from "./styles.module.scss";
import close from "../../../shared/images/close-menu.svg";
import backArrow from "../../../shared/images/back-arrow.svg";
import { logout } from "../../../services/loginService";
import { useHistory } from "react-router-dom";
import { useStoreon } from "storeon/react";
import { LOGOUT } from "../../../store/auth";
import { Role } from "../../../shared/utils/constants/roles";
import ProtectedComponent from "../../../shared/utils/protectedComponent";

let trackingLinksWay = [];
const headMenuLabels = new Map([
  ["main", "Menu"],
  ["superAdmin", "Super Admin"],
  ["settings", "Settings"],
]);

const Menu = (props) => {
  const [activeTab, setActiveTab] = useState();
  const [activeTabLabel, setActiveTabLabel] = useState();
  const { dispatch, auth} = useStoreon(
    "auth",
  );
  const loggedInUser = localStorage.getItem("loggedInUser");
  const loggedInUserObj = loggedInUser && JSON.parse(loggedInUser);
  const history = useHistory();

  useEffect(() => {
    setActiveTab("main");
    trackingLinksWay = [];
    setActiveTabLabel(headMenuLabels.get("main"));

    if (props.open) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "";
    }
  }, [props.open]);

  const onOpenSubmenuHandler = (prev, curr) => {
    trackingLinksWay.push(prev);
    setActiveTab(curr);
    setActiveTabLabel(headMenuLabels.get(curr));
  };

  const onGoBackSubmenuHandler = () => {
    const active = trackingLinksWay.pop();
    setActiveTab(active);
    setActiveTabLabel(headMenuLabels.get(active));
  };

  const onLogoutHandler = () => {
    logout(auth);
    dispatch(LOGOUT);
    history.push("/");
  };

  const onNavigateHandler = (route) => {
    props.close();
    history.push(route);
  };

  return (
      <div className={`${styles.menu} ${props.open ? styles.open : ""}`}>
          <div className={styles.head}>
              {activeTab !== "main" && (
                  <button
                      className={styles.backArrowButton}
                      onClick={onGoBackSubmenuHandler}
                  >
                      <img src={backArrow} alt="back menu" />
                  </button>
              )}
              <span className={styles.headLabel}>{activeTabLabel}</span>
              <button className={styles.closeButton} onClick={props.close}>
                  <img src={close} alt="close menu" />
              </button>
          </div>
          <div className={styles.lines}></div>
          {activeTab === "main" && (
              <div className={styles.links}>
                  <button
                      className={styles.linkMenu}
                      onClick={() => onNavigateHandler("/")}
                  >
                      Live Scoring Set Up
                  </button>
                  <ProtectedComponent roles={[Role.SuperAdmin, Role.Admin]}>
                      <button
                          className={styles.linkMenu}
                          onClick={() =>
                              onOpenSubmenuHandler("main", "superAdmin")
                          }
                      >
                          Super Admin
                      </button>
                  </ProtectedComponent>

                  <button
                      className={styles.linkMenu}
                      onClick={() => onNavigateHandler("/profile")}
                  >
                      Profile
                  </button>
                  <button
                      className={styles.linkMenu}
                      onClick={() => onOpenSubmenuHandler("main", "settings")}
                  >
                      Settings
                  </button>
                  <button className={styles.linkMenu} onClick={onLogoutHandler}>
                      Logout
                  </button>
              </div>
          )}
          {activeTab === "settings" && (
              <div className={styles.links}>
                  <button
                      className={styles.linkMenu}
                      onClick={() => onNavigateHandler("/settings-general")}
                  >
                      General Settings
                  </button>
                  {loggedInUserObj.accountType !== "Freemium" && (
                      <>
                          <button
                              className={styles.linkMenu}
                              onClick={() =>
                                  onNavigateHandler("/settings-cards")
                              }
                          >
                              Scorecard Settings
                          </button>
                          <button
                              className={styles.linkMenu}
                              onClick={() =>
                                  onNavigateHandler("/settings-tables")
                              }
                          >
                              Score Tables Settings
                          </button>
                          <button
                              className={styles.linkMenu}
                              onClick={() =>
                                  onNavigateHandler(routes.Themes.LIST)
                              }
                          >
                              Themes
                          </button>
                      </>
                  )}
              </div>
          )}
          {activeTab === "superAdmin" && (
              <div className={styles.links}>
                  <button
                      className={styles.linkMenu}
                      onClick={() => onNavigateHandler("/users")}
                  >
                      Manage Users
                  </button>
              </div>
          )}
      </div>
  );
};

export default Menu;
